import { render, staticRenderFns } from "./waterfall.vue?vue&type=template&id=03bb9984&scoped=true"
import script from "./waterfall.vue?vue&type=script&lang=js"
export * from "./waterfall.vue?vue&type=script&lang=js"
import style0 from "./waterfall.vue?vue&type=style&index=0&id=03bb9984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bb9984",
  null
  
)

export default component.exports